<template>
  <modal
    :title="`Import ${platform.name} Posts`"
    size="md"
    :body-style="{padding: 0}"
    ref="modal"
  >
    <create-post-import
      v-if="platform.auth === null"
      :platform="platform"
      :get-account-id="accountIdProvider"
      @created="hide()"
    />
    <connect-account
      v-else-if="!account"
      :platform="platform"
    >
      <connect-btn
        :social-site="platform"
        :client-id="clientId"
        color="primary"
        icon-right="fa fa-arrow-right"
        label="Get Started"
        rounded
        @connected="hide()"
      />
    </connect-account>
    <connect-account v-else :platform="platform">
      <reconnect-btn
        :account="account"
        color="primary"
        icon-right="fa fa-arrow-right"
        label="Get Started"
        rounded
        @reconnected="hide()"
      />
    </connect-account>
    <request-support
      :platform="platform.name"
      :get-account-id="accountIdProvider"
    />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { Platform, Account } from '@/social/types';
import { add } from '@/social/account';
import ConnectBtn from '@/social/account/action/connect/ConnectBtn.vue';
import ReconnectBtn from '@/social/account/action/reconnect/ReconnectBtn.vue';
import clientRepository from '@/client/client-repository';
import CreatePostImport from '../file/CreatePostImport.vue';
import ConnectAccount from '../ConnectAccount.vue';
import RequestSupport from '../support/RequestSupport.vue';

interface Data {
  account: Account|null,
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    ReconnectBtn,
    ConnectBtn,
    RequestSupport,
    Modal,
    CreatePostImport,
    ConnectAccount,
  },
  props: {
    platform: {
      type: Object as () => Platform,
      required: true,
    },
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      account: null,
    };
  },
  methods: {
    async getExternalId(): Promise<string|undefined> {
      if (this.platform.auth === null) {
        const client = await clientRepository.find(this.clientId);
        return client.email;
      }
      return undefined;
    },
    async addAccount(): Promise<Account> {
      return add({
        clientId: this.clientId,
        socialSiteId: this.platform.id,
        externalId: await this.getExternalId(),
      });
    },
    async accountIdProvider(): Promise<number> {
      if (this.account) return this.account.id;
      this.account = await this.addAccount();
      return this.account.id;
    },
  },
});
</script>
